import { isTestAccountEmail } from './testAccounts';

/**
 * Platformbeheerders - zelfde set als `App.tsx` (`adminEmails`).
 * Alleen voor client-side UI (menu's, stats); serverregels blijven leidend.
 */
const PLATFORM_ADMIN_EMAILS = [
  'info@superkonnected.nl',
  'support@superkonnected.nl',
  'bussinesssecurit@gmail.com',
] as const;

export function isPlatformAdminEmail(email: string | null | undefined): boolean {
  if (!email || typeof email !== 'string') return false;
  const normalized = email.trim().toLowerCase();
  return PLATFORM_ADMIN_EMAILS.some((e) => e === normalized);
}

/** Admin-only platformstatistieken; testaccounts nooit (zelfde e-mails als `useUserEntities`). */
export function canSeePlatformOnlineStats(email: string | null | undefined): boolean {
  return isPlatformAdminEmail(email) && !isTestAccountEmail(email);
}
